import React, { useState, useContext } from 'react'
import EquipmentService from '../../../../../services/api/equipment.service'
import { store } from '../../../../../context/StateProvider'
import EquipmentForm from '../equipment-form/EquipmentForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'

const AddEquipment = (props) => {
    const {inputChange} = props;
    const [formData, setFormData] = useState(props.initialData||{})
    const [messages, setMessages] = useState({})
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse,setApiResponse] = useState()
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    
    const onSuccess = (message) => {
        dispatch({
            type: "setLocationEquipment",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }
    const submitHandler = (data) => {
        setIsLoader(true)

        if (!data?.practiceLocationRoomId || data?.practiceLocationRoomId=="")
        {
            delete data.practiceLocationRoomId
        }
                
        EquipmentService.addEquipment(data)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    const clearForm = () => {
        setFormData({})
    }
    return (
        <>
            {isLoader && <DimLoader />}
            <EquipmentForm submitHandler={submitHandler} initialData={formData} inputChange={inputChange} onClose={()=>props.onClose() } submitLabel="Add" messages={messages} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </>
    )
}

export default AddEquipment